import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../../tailwind.config';

export const CrmActivityNoteItem: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['status-enquiry'], background = theme.colors['white'] }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill={background} />
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#EAE9E8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 8.5H17.25V9.66667L6.75 9.6725V8.5ZM17.25 11.4225L6.75 11.4167V12.5833H17.25V11.4225ZM6.75 14.3333H13.75V15.5H6.75V14.3333Z"
        fill={fill}
      />
    </svg>
  )
);
